// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardValidations.bs.js";

function CardSchemeComponent$CoBadgeCardSchemeDropDown(props) {
  let setCardBrand = props.setCardBrand;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  return JsxRuntime.jsxs("select", {
    children: [
      JsxRuntime.jsx("option", {
        children: "Select a card brand",
        disabled: true
      }),
      props.eligibleCardSchemes.map((item, i) => JsxRuntime.jsx("option", {
        children: item,
        value: item
      }, i.toString()))
    ],
    className: "w-4",
    onChange: ev => {
      let target = ev.target;
      let value = target.value;
      setCardBrand(param => value);
    },
    onClick: param => loggerState.setLogInfo("CardSchemeMenu expanded", "CARD_SCHEME_SELECTION", undefined, undefined, undefined, undefined, undefined)
  });
}

let CoBadgeCardSchemeDropDown = {
  make: CardSchemeComponent$CoBadgeCardSchemeDropDown
};

function CardSchemeComponent(props) {
  let isCoBadgedCardDetectedOnce = props.isCoBadgedCardDetectedOnce;
  let cardBrand = props.cardBrand;
  let paymentType = props.paymentType;
  let cardNumber = props.cardNumber;
  let cardType = React.useMemo(() => CardUtils$OrcaPaymentPage.getCardType(cardBrand), [cardBrand]);
  let animate = cardType === "NOTFOUND" ? "animate-slideLeft" : "animate-slideRight";
  let cardBrandIcon = React.useMemo(() => CardUtils$OrcaPaymentPage.getCardBrandIcon(cardType, paymentType), [cardBrand]);
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let forwardedSupportedCardBrands = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.supportedCardBrands);
  let enabledCardSchemes = forwardedSupportedCardBrands !== undefined ? forwardedSupportedCardBrands : Core__Option.getOr(PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue), []);
  let matchedCardSchemes = CardValidations$OrcaPaymentPage.getAllMatchedCardSchemes(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber));
  let eligibleCardSchemes = CardUtils$OrcaPaymentPage.getEligibleCoBadgedCardSchemes(matchedCardSchemes, enabledCardSchemes);
  let isCardCoBadged = eligibleCardSchemes.length > 1;
  let marginLeft = isCardCoBadged ? "-ml-2" : "";
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let cardBrandIconSetting = Core__Option.getOr(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardBrandIconOverride), CardUtils$OrcaPaymentPage.getLayoutClass(match.layout).cardBrandIcon);
  let shouldShowCoBadgeCardSchemeDropDown = isCardCoBadged && CardValidations$OrcaPaymentPage.clearSpaces(cardNumber).length >= 16;
  let showCardBrandIcon = CardUtils$OrcaPaymentPage.getCardBrandIconVisibility(cardBrandIconSetting, cardType);
  React.useEffect(() => {
    if (shouldShowCoBadgeCardSchemeDropDown && !isCoBadgedCardDetectedOnce.current) {
      isCoBadgedCardDetectedOnce.current = true;
      loggerState.setLogInfo("Card detected as co-badged", "CARD_SCHEME_SELECTION", undefined, undefined, undefined, undefined, undefined);
    }
  }, [shouldShowCoBadgeCardSchemeDropDown]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: showCardBrandIcon,
        children: cardBrandIcon
      }),
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: shouldShowCoBadgeCardSchemeDropDown,
        children: JsxRuntime.jsx(CardSchemeComponent$CoBadgeCardSchemeDropDown, {
          eligibleCardSchemes: eligibleCardSchemes,
          setCardBrand: props.setCardBrand
        })
      })
    ],
    className: animate + ` flex items-center ` + marginLeft + ` hellow-rodl`
  });
}

let make = CardSchemeComponent;

export {
  CoBadgeCardSchemeDropDown,
  make,
}
/* jotai Not a pure module */
